import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "../../lib/api";

const EMOJI = { heart: "❤️", clap: "👏" };
const WORD = { heart: "sent a heart", clap: "sent a clap" };

// A small encouragement moment: unseen reactions other family members left
// on YOUR Navigator activity. Dismissing marks them seen — each shows once.
export const ReactionAlerts = () => {
  const [alerts, setAlerts] = useState(null);

  useEffect(() => {
    api.get("/opportunities/reaction-alerts")
      .then(({ data }) => setAlerts(data.alerts))
      .catch(() => setAlerts(null));
  }, []);

  const dismiss = () => {
    api.post("/opportunities/reaction-alerts/seen").catch(() => {});
    setAlerts([]);
  };

  if (!alerts?.length) return null;
  return (
    <div className="rounded-2xl border border-rose-200 bg-rose-50/70 p-4 flex items-start gap-3"
      data-testid="reaction-alerts">
      <div className="space-y-1 flex-1">
        {alerts.slice(0, 3).map((a, i) => (
          <p key={`${a.when}-${i}`} className="text-xs" data-testid={`reaction-alert-${i}`}>
            <span aria-hidden="true">{EMOJI[a.reaction]}</span>{" "}
            <span className="font-semibold">{a.reactor}</span> {WORD[a.reaction]} on{" "}
            <span className="font-semibold">{a.title}</span>
          </p>
        ))}
        {alerts.length > 3 && (
          <p className="text-[11px] text-muted-foreground">
            +{alerts.length - 3} more cheer{alerts.length - 3 === 1 ? "" : "s"} from your family
          </p>
        )}
      </div>
      <button type="button" onClick={dismiss} aria-label="Dismiss family cheers"
        className="text-muted-foreground hover:text-foreground transition-colors"
        data-testid="reaction-alerts-dismiss">
        <X className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
};
